import { Injectable } from '@angular/core';
import { PersonalInfo } from './personal-info';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PersonalInfoService {
  personalInfo!: PersonalInfo
  personalForm!: FormGroup;

  constructor() { }
}
